import React from "react";
import { Calendar, Clock } from "lucide-react";
import { useI18n } from "../i18n";
import { fileUrl } from "../lib/api";

export default function EventCard({ event }) {
  const { lang, t } = useI18n();
  const title = lang === "es" ? event.title_es : event.title_en;
  const desc = lang === "es" ? event.desc_es : event.desc_en;
  const recurring = lang === "es" ? event.recurring_es : event.recurring_en;
  const dateStr = recurring
    ? recurring
    : (event.date ? new Date(event.date + "T00:00:00").toLocaleDateString(lang === "es" ? "es-NI" : "en-US", { weekday: "long", day: "numeric", month: "long" }) : "");

  return (
    <div data-testid={`event-card-${event.id}`} className="bg-[#112240]/90 border border-slate-700/60 hover:border-amber-500/40 rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1 shadow-xl">
      {event.flyer && (
        <div className="h-52 overflow-hidden">
          <img src={fileUrl(event.flyer)} alt={title} className="w-full h-full object-cover" />
        </div>
      )}
      <div className="p-6">
        <h3 className="font-display text-xl text-white">{title}</h3>
        <div className="flex flex-wrap gap-4 mt-3 text-sm text-amber-300">
          {dateStr && <span className="inline-flex items-center gap-1.5 capitalize"><Calendar className="h-4 w-4" /> {dateStr}</span>}
          {event.time && <span className="inline-flex items-center gap-1.5"><Clock className="h-4 w-4" /> {t.events.at} {event.time}</span>}
        </div>
        {desc && <p className="text-slate-400 text-sm mt-3 leading-relaxed">{desc}</p>}
      </div>
    </div>
  );
}
